import * as React from 'react'
import * as Styled from './Pullquote.styles'

import Typography from '../Typography'

const Pullquote = ({ children, cite = '' }) => (
  <div>
    <Typography
      variant="h4"
      rendersAs="blockquote"
      className="leshen-pullquote"
    >
      {children}
    </Typography>
    {cite && (
      <Styled.Cite variant="feature" rendersAs="span" className="cite">
        {cite}
      </Styled.Cite>
    )}
  </div>
)

export default Pullquote
